import { AxiosError } from 'axios'

import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import { httpClient } from 'shared/lib'

import { FetchErpProductType, GetWholesalesType, WholesaleStateType } from './types'

export function fetchErpData(searchPhrase: string) {
   let errMessage = ''
   return httpClient
      .get<FetchErpProductType>(`products/erp_search?searchPhrase=${searchPhrase}`)
      .then((response) => {
         if (response.data) {
            return response.data
         }
         throw new Error('noData')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ERP_PRODUCT_CARD fetchErpData service', errMessage, 'error')
         throw error
      })
}

export function getWholesalesService(productUuid: string): Promise<WholesaleStateType> {
   let errMessage = ''
   return httpClient
      .get<GetWholesalesType>(`products/wholesalePrices?productUUID=${productUuid}`)
      .then((response) => {
         if (response.data) {
            return { uuid: productUuid, wholesales: [...response.data] }
         }
         throw new Error('noData')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ERP_PRODUCT_CARD getWholesales service', errMessage, 'error')
         throw error
      })
}
